import React, { useState } from "react";
import FadeInSection from "./FadeInSection"; // Import animation wrapper
import "./Demos.css"; // Import the CSS file

import MarketingAgent from "./MarketingAgent";
import DecisionAgent from "./DecisionAgent";
// import Moderation from "./Moderation";
import DataAPIOperatorAgent from "./DataAPIOperatorAgent";
import DataAPIAggregatorAgent from "./DataAPIAggregatorAgent";
import KD from "./KD";

const Demos = () => {
  const [activeDemo, setActiveDemo] = useState("DataAPIOperatorAgent");

  return (
    <div id="demos">
      <FadeInSection className="demos-container">
        {/* Title Section */}
        <h2 className="demos-title" id="demos">Agent Demos</h2>

        {/* Toggle Bar with Grid Layout */}
        <div className="toggle-bar">

          {/* <button 
            className={activeDemo === "DataAPIAggregatorAgent" ? "active" : ""}
            onClick={() => setActiveDemo("DataAPIAggregatorAgent")}
          >
            Data API Aggregator Agent
          </button> */}

          <button 
            className={activeDemo === "DataAPIOperatorAgent" ? "active" : ""}
            onClick={() => setActiveDemo("DataAPIOperatorAgent")}
          >
            Data Operator Agent
          </button>

          <button 
            className={activeDemo === "MarketingAgent" ? "active" : ""}
            onClick={() => setActiveDemo("MarketingAgent")}
          >
            Core Docs Agent
          </button>
          <button 
            className={activeDemo === "DecisionAgent" ? "active" : ""}
            onClick={() => setActiveDemo("DecisionAgent")}
          >
            Niche Agents
          </button>
          {/* <button 
            className={activeDemo === "KD" ? "active" : ""}
            onClick={() => setActiveDemo("KD")}
          >
            Knowledge Distillation
          </button> */}
        </div>

        {/* Dynamic Demo Content */}
        <div className="demo-content">
          {activeDemo === "DataAPIOperatorAgent" && <DataAPIOperatorAgent />}
          {activeDemo === "MarketingAgent" && <MarketingAgent />}
          {activeDemo === "DecisionAgent" && <DecisionAgent />}
          {activeDemo === "DataAPIAggregatorAgent" && <DataAPIAggregatorAgent />}            
          {activeDemo === "KD" && <KD />}            
        </div>
      </FadeInSection>
    </div>
  );
};

export default Demos;
